import React from "react";
import { Container, Row } from "reactstrap";

import DetailsSection from "./DetailSection";
import Overview from "./Overview";

const CreditDetails = () => {
  document.title = "Ditobanx";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Row>
            <Overview />
            <DetailsSection />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreditDetails;
